import * as z from "zod";

const NullableDateSchema = z
  .string()
  .or(z.date())
  .transform((value) => (value ? new Date(value) : null))
  .pipe(z.date())
  .nullable();

export const HangerHistoryItemSchema = z.object({
  id: z.string().default(""),
  accountFirstName: z
    .string()
    .nullable()
    .optional()
    .transform((r) => (r ? r.trim() : "")),
  accountLastName: z
    .string()
    .nullable()
    .optional()
    .transform((r) => (r ? r.trim() : "")),
  accountEmail: z
    .string()
    .nullable()
    .optional()
    .transform((r) => (r ? r.trim() : "")),
  checkedInAt: z
    .string()
    .or(z.date())
    .transform((v) => new Date(v)),
  checkedOutAt: NullableDateSchema,
});

export type HangerHistoryItem = z.infer<typeof HangerHistoryItemSchema>;
